import ENV from "config/Env";
import { backendQueryKey } from "hooks";
import { UPDATE_TYPE, backendQueryKey as untypedBackendQueryKey } from "utils/keyFactory";

const component = "LocationReports";

export const LocationReportQueryKeys = {
  listGroups: (dealer_location_id: number) =>
    backendQueryKey<number[]>({ component, baseUrl: ENV.reportsBaseURL, endpoint: "/locations/list_groups", params: { dealer_location_id } }),

  listReports: (dealer_location_id: number, template_group: number) =>
    backendQueryKey<number[]>({ component, baseUrl: ENV.reportsBaseURL, endpoint: "/locations/list", params: { dealer_location_id, template_group } }),

  locationReport: (index: number, dealer_location_id: number, report_id: number, date_from?: string, date_to?: string) => [
    untypedBackendQueryKey({
      updateType: UPDATE_TYPE.Static,
      component,
      baseUrl: ENV.reportsBaseURL,
      endpoint: "/locations/view",
      params: { index, dealer_location_id, report_id, ...(date_from && date_to ? { date_from, date_to } : {}) }
    })
  ]
};
